var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-width mx-auto my-3"},[_c('Breadcrumb'),(!_vm.$route.meta.hideContentTitle)?_c('div',{staticClass:"content-title"},[_vm._v(_vm._s(_vm.$t(_vm.$route.meta.title)))]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }